document.addEventListener('DOMContentLoaded', function () {
    function initPageInfiniteScroll({
        pages = [],
        containerSelector = "#MainContent",
        sectionSelector = ".shopify-section",
        offset = 1000
    }) {

        const container = document.querySelector(containerSelector);
        if (!container || !pages.length) return;

        let currentIndex = 0;
        let loading = false;
        // ===== CREATE LOADER =====
        const loader = document.createElement("div");
        loader.className = "infinite-scroll-loader";
        loader.innerHTML = `
        <span class="scroll-spinner"></span>
        `;
        loader.style.display = "none";
        container.after(loader);
        function showLoader() {
            loader.style.display = "flex";
        }

        function hideLoader() {
            loader.style.display = "none";
        }

        async function loadNextPage() {
            if (loading || currentIndex >= pages.length) return;

            loading = true;
            showLoader();

            try {
                const response = await fetch(pages[currentIndex], {
                    credentials: "same-origin"
                });

                const html = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const newContainer = doc.querySelector(containerSelector);
                if (!newContainer) {
                    loading = false;
                    hideLoader();
                    return;
                }

                const newSections = newContainer.querySelectorAll(sectionSelector);

                newSections.forEach(section => {
                    container.appendChild(section);
                });

                if (window.Shopify && Shopify.designMode) {
                    document.dispatchEvent(new Event("shopify:section:load"));
                }

                if (window.theme && typeof theme.init === "function") {
                    theme.init();
                }
                console.log(window.Instafeed);

                currentIndex++;
                loading = false;
                hideLoader();

            } catch (error) {
                console.error("Infinite scroll error:", error);
                loading = false;
            }
        }

        function handleScroll() {
            if (
                window.innerHeight + window.scrollY >=
                document.body.offsetHeight - offset
            ) {
                loadNextPage();
            }
        }

        window.addEventListener("scroll", handleScroll);
    }
    initPageInfiniteScroll({
        pages: window._pageHandle
    });
});